'use client';

import { FC, FocusEventHandler, forwardRef, InputHTMLAttributes, useRef } from 'react';
import PhoneInput, { Country, Value } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import CountrySelect from '@/hotdesk-ui/components/shared/CountrySelect';
import { useDefaultPhoneCountry } from '@/hotdesk-ui/hooks/useDefaultPhoneCountry';
import { usePhoneLabels } from '@/hotdesk-ui/lib/phone-labels';
import styles from './PhoneField.module.scss';
interface PhoneFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  placeholder?: string;
  defaultCountry?: Country;
  error?: string;
  disabled?: boolean;
}
const InputControl = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>((props, ref) => <input ref={ref} {...props} className={styles.input} />);
InputControl.displayName = 'PhoneFieldInput';
const PhoneField: FC<PhoneFieldProps> = ({
  value,
  onChange,
  onBlur,
  placeholder,
  defaultCountry,
  error,
  disabled
}) => {
  const labels = usePhoneLabels();
  const geoCountry = useDefaultPhoneCountry();
  const resolvedCountry = defaultCountry ?? geoCountry;
  const inputKeyRef = useRef(`phone-${resolvedCountry}`);
  if (!value) {
    inputKeyRef.current = `phone-${resolvedCountry}`;
  }
  return <div className={styles.field} data-sentry-component="PhoneField" data-sentry-source-file="PhoneField.tsx">
            <div className={`${styles.wrap} ${error ? styles.invalid : ''}`.trim()}>
                <PhoneInput key={inputKeyRef.current} defaultCountry={resolvedCountry} value={value as Value | undefined} onChange={(v?: Value) => onChange(v ?? '')} onBlur={onBlur} placeholder={placeholder} disabled={disabled} labels={labels} inputComponent={InputControl} countrySelectComponent={CountrySelect} className={styles.phoneInput} data-sentry-element="PhoneInput" data-sentry-source-file="PhoneField.tsx" />
            </div>
            {error && <p className={styles.error}>{error}</p>}
        </div>;
};
export default PhoneField;